import { Box, CircularProgress, Dialog } from '@mui/material';

export const LoadingDialog = ({ unmount }: { unmount?: () => void }) => (
  <Dialog open onClose={unmount} maxWidth='sm' fullWidth scroll='paper'>
    <Box
      sx={{
        minHeight: '50vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  </Dialog>
);
